<ngx-skeleton-loader
  [count]="count()"
  [animation]="'progress'"
  [theme]="mergedTheme()"
  [appearance]="realAppearance()"
></ngx-skeleton-loader>
